<template>
  <hm-sync :value="value">
    <div>
      <div class="table-panel flex flex-between">
        <div>
          <el-button
            class="mr10"
            type="primary"
            size="small"
            @click="addSpecification"
            >新增规格类型</el-button
          >
        </div>
        <div>
          <el-input
            clearable
            v-model.trim="keyWords"
            placeholder="请输入规格类型"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
          <el-button
            type="success"
            size="small"
            @click="output(allSpecificationList, 'specTable', '辅助属性列表')"
            :loading="isOutputing"
            >导出</el-button
          >
        </div>
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        @sort-change="sortChange"
        ref="specTable"
        :data="specificationList.records"
        style="width: 100%"
        id="table"
        size="small"
        border
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="typeName"
          label="规格类型"
        ></el-table-column>
        <el-table-column
          header-align="center"
          show-overflow-tooltip
          align="center"
          prop="specNum"
          label="规格数量"
          sortable
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="valueNum"
          label="规格值数量"
          sortable
        ></el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="查看" placement="top">
                <button
                  class="pointer mr10 no-bg"
                  @click="toDetails(scope.row)"
                >
                  <span class="hmicon icon-chakan blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip class="item" content="编辑" placement="top">
                <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                  <span class="hmicon icon-bianji blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip class="item" content="删除" placement="top">
                <button class="pointer mr10 no-bg" @click="remove(scope.row)">
                  <span class="hmicon icon-shanchu primary"></span>
                </button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="specificationList.total"
        @size-change="handleSizeChange"
        :page-sizes="[10, 50, 100, 200]"
        @current-change="paging"
        layout="total,sizes,  prev, pager, next, jumper, sizes"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
  </hm-sync>
</template>

<script>
import HmSync from "@/components/HmIsSync";
import { mapGetters } from "vuex";
import { outPutMixin } from "@/mixins/outputMixin";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: { HmSync },
  data() {
    return {
      sort: {},
      value: true,
      actName: "",
      currentPage: 1,
      pageSize: 10,
      isOutputing: false,
      keyWords: ""
    };
  },
  mixins: [outPutMixin],
  computed: mapGetters(["specificationList", "allSpecificationList"]),
  created() {
    this.getParamsCookie();
  },
  mounted() {
    this.queryList();
  },
  methods: {
    sortChange(sort) {
      this.sort = sort;
      this.queryList(sort);
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    addSpecification() {
      this.$router.push({
        name: "AddSpecification"
      });
    },
    toDetails(row) {
      this.$router.push({
        name: "SpecDetails",
        query: {
          id: row.typeId
        }
      });
    },
    edit(row) {
      this.$router.push({
        name: "EditSpec",
        query: {
          id: row.typeId
        }
      });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    queryList(queryAll) {
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: this.currentPage,
        keyWords: this.keyWords,
        order: this.sort.order,
        prop: this.sort.prop
      };
      this.setParamsCookie();
      const actionName = queryAll
        ? "queryAllSpecificationList"
        : "querySpecificationList";
      return this.$store.dispatch(actionName, params);
    },
    setParamsCookie() {
      let searchCondition = {
        keyWords: this.keyWords,
        order: this.sort.order,
        prop: this.sort.prop
      };
      setCookie({
        key: "specificationParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "specificationParams", type: "session" });
      if (prams) {
        this.keyWords = prams.keyWords;
        this.sort.order = prams.order;
        this.sort.prop = prams.prop;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("deleteSpecification", {
            typeId: row.typeId
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    }
  }
};
</script>
<style scoped lang="scss">
.title {
  font-size: 22px;
  font-weight: bold;
}
.switch {
  margin-right: 40%;
}
</style>
